import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

import FooterLinks from "./footer-links";
import footerlogo from "../../assets/images/logo/horizontal-white-text.svg";

class Footer extends Component {
  state = {
    footerItems: [
      {
        title: "Company",
        links: [
          { linkTitle: "For dermatologists", link: "/for-dermatologists" },
          { linkTitle: "Terms and conditions", link: "/terms-and-conditions" },
          { linkTitle: "Informed consent", link: "/informed-consent" },
          { linkTitle: "Privacy", link: "/privacy" },
          { linkTitle: "Telemedicine", link: "/telemedicine" },
        ],
      },
      {
        title: "Contact Us",
        links: [
          { linkTitle: "Email", link: "mailto:support@drderma.co.za?subject=New%20Support%20Ticket" },
        ],
      },
      {
        title: "Treatment",
        links: [
          { linkTitle: "Start a consultation", link: "/consultation/start" },
          { linkTitle: "Find a dermatologist", link: "/dermatologists" },
        ],
      },
    ],
    socialIcons: [
      { icon: "remixicon-facebook-line", iconLink: "https://www.facebook.com/drderma.southafrica" },
      { icon: "remixicon-instagram-line", iconLink: "https://www.instagram.com/dr_derma_sa" },
      { icon: "remixicon-linkedin-line", iconLink: "https://www.linkedin.com/company/dr-derma-southern-africa/" },
    ],
  };

  render() {
    return (
      <React.Fragment>
        {/* FOOTER START  */}
        <footer className="pt-5 position-relative" style={{backgroundColor: '#6C6D6F'}}>
          <Container className="container">
            <Row>
              <Col lg={3}>
                <div className="footer-about-content mt-4">
                  <img
                    src={footerlogo}
                    alt="footerLogo"
                    className="img-fluid"
                    style={{opacity: 0.75, maxWidth: 200}}
                  />
                  <p className="mt-4 text-light f-15">
                    Medical-grade online dermatology
                  </p>
                  <ul className="list-inline footer-icon mt-4">
                    {this.state.socialIcons.map((item, key) => (
                      <li className="list-inline-item h4 mr-4" key={key}>
                        <a target="_blank" href={item.iconLink} className="text-light">
                          <i className={item.icon} />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col lg={8} className="offset-lg-1">
                <div className="row">
                  {this.state.footerItems.map((item, key) => (
                    <div className="col-md-4" key={key}>
                      <div className="mt-4">
                        <h5 className="text-light font-weight-medium mb-4">
                          {item.title}
                        </h5>
                        <ul className="list-unstyled">
                          {item.links.map((fLink, key) => (
                            <li className="f-15 mt-1 mb-1" key={key}>
                              <a href={fLink.link} className="text-light">
                                {fLink.linkTitle}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
          <FooterLinks />
        </footer>

        {/* FOOTER END  */}
      </React.Fragment>
    );
  }
}

export default Footer;
